import problem from "../../../images/icon/problem.svg";
import solution from "../../../images/icon/solution.svg";

export const RecruitmentTargetAdvantages = () => {
  return (
    <section className="section-sp1">
      <div className="container inner-content">
        <div className="solution-cards">
          <div
            className="problem-card"
            style={{
              background: "#FFF7F7",
              maxWidth: "630px",
              minHeight: "300px",
              padding: "30px",
              boxShadow:
                "0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A",
            }}
          >
            <img src={problem} alt="" />
            <h3 style={{ color: "#EC0D0D", marginBlock: "10px" }}>
              The Challenge
            </h3>
            <p>
              Traditional recruitment methods struggle to reach passive
              candidates—HCPs who are employed but open to new opportunities.
              Cold outreach lacks context, and job boards miss the mark.
            </p>
          </div>
          <div
            className="solution-card"
            style={{
              background: "#FCFFF9",
              boxShadow:
                "0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A",
              maxWidth: "630px",
              minHeight: "300px",
              padding: "30px",
            }}
          >
            <img src={solution} alt="" />
            <h3 style={{ color: "#7BD825", marginBlock: "10px" }}>
              Our Solution
            </h3>
            <span>
              We help you reach your ideal HCP candidates by specialty,
              geography, and more—then deliver warm leads straight to your team.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
